import React from 'react';
import { CheckIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { productImageUrl } from '../data/product';
const benefits = ['6 volumes + 5 bonuses', '60+ ready-to-coach sessions', 'Beginner to pro'];
const assurances = [{
  icon: LockKeyholeIcon,
  label: 'Secure checkout'
}, {
  icon: ZapIcon,
  label: 'Instant delivery'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function HeroSection() {
  return <section className="flex min-h-[100svh] w-full items-center bg-stone-50 px-5 py-5 sm:py-8" data-id="element-84" data-mp="30lauhni8kck7">
      <div className="mx-auto grid w-full max-w-6xl items-center gap-6 lg:grid-cols-[1fr_1fr] lg:gap-12" data-id="element-85" data-mp="2mtxdag7svqsc">
        <div className="text-center lg:text-left" data-id="element-86" data-mp="2rt0grw84toy7">
          <p className="inline-flex items-center gap-2 border border-line bg-white px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[.16em] text-sage-700 sm:text-[10px]" data-id="element-87" data-mp="2rrfokd9aii3i">
            <span className="h-1.5 w-1.5 rounded-full bg-clay-500" data-id="element-88" data-mp="3kacwj7e1bo62" />
            The complete toolkit for functional coaches
          </p>
          <h1 className="mt-3 font-display text-[1.75rem] font-bold uppercase leading-[1] tracking-[.01em] text-ink-900 sm:text-4xl lg:mt-4 lg:text-[3rem]" data-id="element-89" data-mp="2fdfnhe059mnf">
            Plan your entire year of functional sessions
            <span className="block font-semibold normal-case italic tracking-normal text-clay-500" data-id="element-90" data-mp="2p76b6gog5t22">
              in under 5 minutes.
            </span>
          </h1>
          <div className="mx-auto mt-4 w-full max-w-[300px] sm:max-w-[360px] lg:hidden" data-id="element-91" data-mp="2z1y7lh6am9v9">
            <img src={productImageUrl} alt="Functional Ready, the complete set of six digital volumes shown on desktop, tablet and phone" width={1280} height={853} fetchPriority="high" className="w-full object-contain" data-id="element-92" data-mp="2u3mxd5c35xci" />
          </div>
          <p className="mx-auto mt-4 max-w-xl text-[13px] leading-relaxed text-ink-600 sm:text-[15px] lg:mx-0" data-id="element-93" data-mp="1ds98w53957cr">
            <strong className="font-semibold text-ink-900" data-id="element-94" data-mp="38tb95o4hi0me">
              FUNCTIONAL READY™
            </strong>{' '}
            is the complete teaching toolkit: 6 professional volumes, 60+
            sessions and every resource you need to lead elite functional
            training.
          </p>
          <ul className="mx-auto mt-4 flex max-w-xl flex-wrap justify-center gap-x-4 gap-y-1.5 text-[13px] font-medium text-ink-800 lg:mx-0 lg:justify-start" data-id="element-95" data-mp="3mt498a1wht71">
            {benefits.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-96" data-mp="lw5fc6mpud4">
                <CheckIcon className="h-3.5 w-3.5 shrink-0 text-sage-600" data-id="element-97" data-mp="k1mu4ityec7" />
                {item}
              </li>)}
          </ul>
          <a href="#offer-details" className="cta-button mt-5 inline-flex w-full items-center justify-center px-7 py-4 text-sm font-bold uppercase tracking-[.06em] sm:text-base lg:w-auto" data-id="element-98" data-mp="ac7ax35yobm4">
            Get Functional Ready™ now
          </a>
          <div className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-[11px] font-medium text-ink-600 lg:justify-start" data-id="element-99" data-mp="ja18sijdjdbe">
            {assurances.map(({
            icon: Icon,
            label
          }) => <span key={label} className="flex items-center gap-1.5" data-id="element-100" data-mp="1yxo7qogwev4b">
                <Icon className="h-3.5 w-3.5 text-sage-600" data-id="element-101" data-mp="1uu9prs9eg4o8" />
                {label}
              </span>)}
          </div>
        </div>
        <div className="hidden lg:block" data-id="element-102" data-mp="2mknzrdeakwum">
          <img src={productImageUrl} alt="Functional Ready, the complete set of six digital volumes shown on desktop, tablet and phone" width={1280} height={853} fetchPriority="high" className="max-h-[70svh] w-full object-contain" data-id="element-103" data-mp="2mke8znlfalnv" />
          <p className="mx-auto mt-2 w-fit border border-line bg-white px-3 py-1.5 text-center text-[10px] font-semibold uppercase tracking-[.18em] text-ink-700" data-id="element-104" data-mp="28t970eul1had">
            52 weeks · Workouts · Scripts · Progressions
          </p>
        </div>
      </div>
    </section>;
}